"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.climate = void 0;
const basic_1 = require("../basic");
const font_faces_1 = require("./font-faces");
exports.climate = (0, basic_1.applyBase)({
    chartContainer: {
        height: 200,
    },
    chartsWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        mb: [0, '90px'],
    },
    preparedChart: {
        pt: [0, 4],
        px: [4, 7],
        pb: ['40px', 4],
        borderTop: [null, null, '1px solid'],
        borderTopColor: [null, null, 'borderColor'],
        width: ['100%', '50%', '50%'],
        '&:nth-child(1), &:nth-child(3)': {
            borderRight: [null, null, '1px solid'],
            borderRightColor: [null, null, 'borderColor'],
        },
        '&:nth-child(3), &:nth-child(4)': {
            borderBottom: [null, null, '1px solid'],
            borderBottomColor: [null, null, 'borderColor'],
        },
        '.chart-label': Object.assign(Object.assign({}, font_faces_1.FONT_SIZE.LARGE), { pb: [4] }),
        '.label': Object.assign({}, font_faces_1.FONT_SIZE.SMALL),
        '.recharts-cartesian-axis-tick-value': Object.assign({}, font_faces_1.FONT_SIZE.SMALL),
    },
});
//# sourceMappingURL=climate.js.map